import { ApplicationId } from "@1games-ru/region-shared/dist/enums/phone/application-id";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";
import { PhoneSystemAppsListEnum } from "@/domains/phone/constants/phoneSystemAppsListEnum";

export interface PhoneState {
  isShow: boolean;
  appsList: ApplicationId[];
  activeApp: ApplicationId;
  systemActiveApp: PhoneSystemAppsListEnum;
  isVisible: boolean;
}

const initialState: PhoneState = {
  isShow: false,
  appsList: [],
  activeApp: null,
  systemActiveApp: null,
  isVisible: true,
};

const phoneSlice = createSlice({
  name: "phoneSlice",
  initialState,
  reducers: {
    setIsShow: (state, action: PayloadAction<boolean>) => {
      state.isShow = action.payload;
    },
    setAppsList: (state, action: PayloadAction<ApplicationId[]>) => {
      state.appsList = action.payload.sort((a, b) => a - b);
    },
    setActiveApp: (state, action: PayloadAction<ApplicationId>) => {
      state.activeApp = action.payload;
    },
    setSystemActiveApp: (state, action: PayloadAction<PhoneSystemAppsListEnum>) => {
      state.systemActiveApp = action.payload;
    },
  },
});

export const phoneIsShow = (state: RootState) => state.phone.isShow;
export const devicesList = (state: RootState) => state.phone.appsList;
export const phoneActiveApp = (state: RootState) => state.phone.activeApp;
export const phoneSystemActiveApp = (state: RootState) => state.phone.systemActiveApp;

export const phoneReducer = phoneSlice.reducer;
export const { setIsShow, setAppsList, setActiveApp, setSystemActiveApp } = phoneSlice.actions;
